import { ColorEnum } from '@/constants/color'
import { createStyleSheet } from 'react-native-unistyles'

export const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        width: '100%',
    },
    containerLayout: (layout: string) => ({
        justifyContent: layout === 'compact' ? 'flex-start' : 'center',
    }),
    option: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 10,
        paddingHorizontal: 16,
        borderRadius: 24,
        backgroundColor: ColorEnum.Transparent,
    },
    highlight: {
        backgroundColor: ColorEnum.BRICK_600,
        borderRadius: 24,
        position: 'absolute',
        height: '100%',
        left: 0,
        top: 0,
    },
    label: {
        color: ColorEnum.GRAY_900,
        textTransform: 'uppercase',
    },
    labelActive: {
        color: ColorEnum.WHITE,
    },
})
